import { Link, Outlet, useRouterState } from "@tanstack/react-router";
import { Building2, Monitor, Percent, SlidersHorizontal } from "lucide-react";
import { MasterHeader, MasterPage } from "@/components/shared/master-shell";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/settings/company", label: "Company", icon: Building2 },
  { to: "/settings/defaults", label: "Defaults", icon: SlidersHorizontal },
  { to: "/settings/preferences", label: "Preferences", icon: Monitor },
  { to: "/settings/taxes", label: "Taxes", icon: Percent },
] as const;

export function SettingsLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  return (
    <MasterPage>
      <MasterHeader title="Settings" countLabel="Company, defaults, taxes & preferences" />

      <div className="inline-flex h-7 items-center rounded-md border border-border bg-muted/50 p-0.5">
        {TABS.map((tab) => {
          const active = pathname === tab.to || pathname.startsWith(`${tab.to}/`);
          const Icon = tab.icon;
          return (
            <Link
              key={tab.to}
              to={tab.to}
              className={cn(
                "inline-flex h-6 items-center gap-1.5 rounded px-2 text-2xs transition-colors",
                active
                  ? "bg-card font-medium text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              <Icon className="size-3" />
              {tab.label}
            </Link>
          );
        })}
      </div>

      <Outlet />
    </MasterPage>
  );
}
